import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const BrandDoesNotHaveInsiderFreeShippingIA: InstantAnswerBuilderFn = (
  strictLocalize
) => ({
  titleBuilder: (context) => {
    return getAnswer(context, strictLocalize).getTitle();
  },

  descriptionBuilder: (context) => {
    return getAnswer(context, strictLocalize).getDescription();
  },
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () =>
      WHY_BRAND_DOES_NOT_HAVE_INSIDER_FREE_SHIPPING_ANYMORE(strictLocalize),
    getDescription: () => [
      FREE_SHIPPING_COVERAGE_MAY_CHANGE_PERIODICALLY(strictLocalize),
    ],
  };
};

const WHY_BRAND_DOES_NOT_HAVE_INSIDER_FREE_SHIPPING_ANYMORE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "A brand no longer has Insider free shipping",
    description: {
      text: "Title for the answer of A Brand doesn't have Insider free shipping anymore issue",
    },
  });

const FREE_SHIPPING_COVERAGE_MAY_CHANGE_PERIODICALLY = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "Free shipping coverage may change periodically. For example, coverage can change when we make adjustments based on estimated costs or when we’re testing out new factors such as relationship type. This flexibility allows us to offer free shipping on as many orders as possible while keeping the price of your Insider membership affordable. While you may have gotten Insider free shipping on your last order with a specific brand, this brand may no longer be covered for Insider free shipping under your membership. If you’d like to find other brands with Insider free shipping, you can use the Insider filter while shopping or simply look for the Insider key while browsing on Faire.",
  });
